import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';

interface DefaultCoverImage {
  _id: string;
  url: string;
}

export const getDefaultCoverImages = async () => {
  const response =
    await baseAPI.get<Array<DefaultCoverImage>>(`/default-image`);
  return response.data;
};

export const useGetDefaultCoverImages = () => {
  return useQuery({
    queryKey: ['default-cover-images'],
    queryFn: () => getDefaultCoverImages(),
  });
};
